import { create } from 'zustand';

import type { Tool } from '@/types/tool.type';

type ToolsState = {
  selectedTool: Tool | null;
  selectTool: (tool: Tool) => void;
  clearSelectedTool: () => void;
};

export const useToolsStore = create<ToolsState>(set => ({
  selectedTool: null,
  selectTool: tool => set({ selectedTool: tool }),
  clearSelectedTool: () => set({ selectedTool: null }),
}));
